"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const Filter_1 = require("./Filter");
const Store_1 = require("../Store");
let Filters = class Filters extends React.Component {
    constructor(props) {
        super(props);
        //!store.disableBrands ? store.loadBrands() : store.loadProducts();
        Store_1.default.loadBrands();
        Store_1.default.loadCategories();
        if (Store_1.default.SelectedCategories !== null) {
            Store_1.default.loadSubNav();
        }
    }
    OnBrandSelect(brand) {
        Store_1.default.SelectedBrand = brand;
        Store_1.default.SelectedSubNav = null;
        Store_1.default.SelectedCategories.replace([]);
        Store_1.default.loadProducts();
    }
    OnCategorySelect(categories) {
        Store_1.default.SelectedBrand = null;
        Store_1.default.SelectedSubNav = null;
        Store_1.default.SelectedCategories.replace(Array.isArray(categories) ? categories.map(x => x) : [categories]);
        Store_1.default.loadProducts();
        Store_1.default.loadSubNav();
    }
    OnSubNavSelect(subNav) {
        if (Store_1.default.SelectedSubNav !== null && Store_1.default.SelectedSubNav.name == subNav.name) {
            Store_1.default.SelectedSubNav = null;
        }
        else {
            Store_1.default.SelectedSubNav = subNav;
        }
        Store_1.default.loadProducts();
    }
    render() {
        return (React.createElement("div", null,
            React.createElement("h1", { className: "u-tc s-h1" }, Store_1.default.currentPageName),
            React.createElement("div", { className: "o-filters row" },
                React.createElement(Filter_1.default, { allLink: Store_1.default.containerUrlSegment, allOnSelect: () => this.OnBrandSelect(null), name: Store_1.default.SelectedBrand !== null ? Store_1.default.SelectedBrand.name : Store_1.default.Translations.brandsText, onSelect: this.OnBrandSelect.bind(this), selectedFilters: Store_1.default.SelectedBrand !== null ? [Store_1.default.SelectedBrand] : null, filters: Store_1.default.Brands, active: Store_1.default.SelectedBrand !== null || (Store_1.default.SelectedBrand === null && (Store_1.default.SelectedCategories === null || Store_1.default.SelectedCategories.length < 1)) }),
                React.createElement(Filter_1.default, { allLink: Store_1.default.containerUrlSegment + "kaikki", allOnSelect: () => this.OnCategorySelect([{ name: "Kaikki", id: 0, urlSegment: "kaikki" }]), name: Store_1.default.Translations.productTypesText, onSelect: this.OnCategorySelect, onClear: () => this.OnCategorySelect([]), multiselect: false, selectedFilters: Store_1.default.SelectedCategories, filters: Store_1.default.Categories, active: Store_1.default.SelectedCategories !== null && Store_1.default.SelectedCategories.length > 0 })),
            this.props.ingressText != "" &&
                React.createElement("div", { className: "o-ingress row u-maxw-90 _sm-u-maxw-75 u-my-0 u-py-3 color-blue" }, this.props.ingressText),
            Store_1.default.SubNavs &&
                React.createElement("div", { className: "o-subnav row" }, Store_1.default.SubNavs.map((x, i) => React.createElement("a", { key: x.name, onClick: this.OnSubNavSelect.bind(this, x), className: "o-subnav-link u-my-1 ._sm-u-my-3" + ((Store_1.default.SelectedSubNav !== null && Store_1.default.SelectedSubNav.name == x.name) ? " active" : "") },
                    React.createElement("span", null, x.name))))));
    }
};
__decorate([
    mobx_1.action
], Filters.prototype, "OnBrandSelect", null);
__decorate([
    mobx_1.action
], Filters.prototype, "OnCategorySelect", null);
__decorate([
    mobx_1.action
], Filters.prototype, "OnSubNavSelect", null);
Filters = __decorate([
    mobx_react_1.observer
], Filters);
exports.default = Filters;
